export const iseAspectRatioValid = (aspectRatio: string): boolean => /[0-9]+(\/|:)[0-9]+/.test(aspectRatio);
